import { Controller } from "@hotwired/stimulus"

// Chart Data Table Toggle Controller
// Handles showing/hiding accessible data table alternatives for charts
export default class extends Controller {
  static targets = ["toggleButton", "dataTable", "buttonText"]

  connect() {
    // Initialize state from button attributes
    this.expanded = this.toggleButtonTarget.getAttribute('aria-expanded') === 'true'
  }

  toggle(event) {
    event.preventDefault()

    this.expanded = !this.expanded

    // Update visibility
    if (this.expanded) {
      this.dataTableTarget.classList.remove('hidden')
      if (this.hasButtonTextTarget) {
        this.buttonTextTarget.textContent = 'Hide Data Table'
      }
    } else {
      this.dataTableTarget.classList.add('hidden')
      if (this.hasButtonTextTarget) {
        this.buttonTextTarget.textContent = 'View Data Table'
      }
    }

    // Update ARIA attribute for accessibility
    this.toggleButtonTarget.setAttribute('aria-expanded', this.expanded.toString())

    // Optional: Save user preference to localStorage
    this.savePreference()
  }

  savePreference() {
    const tableId = this.dataTableTarget.id
    if (tableId) {
      localStorage.setItem(`chart-table-${tableId}`, this.expanded.toString())
    }
  }

  // Restore preference on page load
  restorePreference() {
    const tableId = this.dataTableTarget.id
    if (tableId) {
      const savedState = localStorage.getItem(`chart-table-${tableId}`)
      if (savedState === 'true') {
        // Simulate toggle to open table
        this.toggle(new Event('click'))
      }
    }
  }

  disconnect() {
    // Cleanup if needed
  }
}
